var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.501,
    height: 18,
    viewBox: "0 0 13.501 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1167 -407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.751,0A6.63,6.63,0,0,0,0,6.75a11.292,11.292,0,0,0,.45,2.7c1.125,2.025,6.3,8.55,6.3,8.55s4.725-5.85,6.076-8.55a6.778,6.778,0,0,0,.675-2.7A6.77,6.77,0,0,0,6.751,0ZM11.7,9a68.661,68.661,0,0,1-4.951,7.2A66.646,66.646,0,0,1,1.575,9a7.993,7.993,0,0,1-.45-2.25A5.571,5.571,0,0,1,6.751,1.125,5.571,5.571,0,0,1,12.376,6.75,5.03,5.03,0,0,1,11.7,9Z",
    transform: "translate(1167 407)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.876,1.5A3.468,3.468,0,0,0,1.5,4.889,3.468,3.468,0,0,0,4.876,8.278,3.468,3.468,0,0,0,8.252,4.889,3.468,3.468,0,0,0,4.876,1.5Zm0,5.648A2.13,2.13,0,0,1,2.625,4.889,2.13,2.13,0,0,1,4.876,2.63,2.13,2.13,0,0,1,7.127,4.889,2.259,2.259,0,0,1,4.876,7.148Z",
    transform: "translate(1168.875 408.867)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/location.f3e6624aea98c4eee600c36a28162678.svg";